/**
 * Hariom ERP - HR store (persisted, starts empty).
 * HR adds employees; record stays until explicitly deleted.
 */
import { createCrudStore } from './createCrudStore'

export interface Employee {
  id: string
  empNo: string
  name: string
  designation: string
  dept: string
  status: string   // active | on_leave | resigned | terminated
  joined: string
  phone: string
}

export const useHRStore = createCrudStore<Employee>('hariom-erp-hr')
